<template>
    <comment-body :comment="comment">
        <template slot="header">
            <a-tag v-if="comment.top    > 0">置顶<a-icon type="pushpin"/></a-tag>
            <a-tag v-if="comment.locked > 0">锁定<a-icon type="lock"   /></a-tag>
        </template>
        <a-button v-if="comment.locked == 0" type="link" @click="triggerWriteboard()">{{ open ? '收起回复' : '回复' }}</a-button>
        <a-button v-if="userid == comment.author.id" type="link" @click="editComment()">编辑</a-button>
        <a-button v-if="userid == comment.author.id" type="link" @click="deleteComment()">删除</a-button>
        <a-button v-if="userid == comment.author.id" type="link" @click="manageComment('locked')">{{ comment.locked == 0 ? '锁定' : '取消锁定' }}</a-button>
        <a-button v-if="userid == app.tower.authorId" type="link" @click="manageComment('top')">{{ comment.top == 0 ? '置顶' : '取消置顶' }}</a-button>
        <a-button class="admin-button" v-else-if="hasDeletePrivilege" type="link" @click="deletecommentByAdmin()">删除</a-button>
        <div slot="append" v-if="comment.replies.length > 0 || open">
            <a-list
                size="small"
                class="subcomment-list"
                item-layout="horizontal"
                :data-source="replies"
            >
                <div slot="header" />
                <a-list-item slot="renderItem" slot-scope="reply">
                    <Subcomment :parent="comment" :reply="reply" @reply="openWriteboard"></Subcomment>
                </a-list-item>
                <div class="expand-button" v-if="needPackup">
                    <a-divider>
                        <a-button type="link" @click="toggleExpand">{{ expand ? '折叠回复' : `展开回复(剩余${ comment.replies.length - 5 }条)` }}</a-button>
                    </a-divider>
                </div>
                <div class="writeboard" v-if="open">
                    <a-textarea v-model="text" ref="writeboard" auto-size></a-textarea>
                    <div class="textbar">
                        <a-button type="primary" size="small" @click="appendSubcomment()"
                            :loading="replying"
                        >发送</a-button>
                    </div>
                </div>
            </a-list>
        </div>
    </comment-body>
</template>

<script>
import CommentBody from './CommentBody.vue';
import Subcomment from './Subcomment.vue';
import { mapState } from 'vuex';
import { checkPrivilege } from '../../admin/privilege';

export default {
    props: {
        comment: Object,
    },
    data: () => ({
        open: false,
        text: "",
        replyto: 0,
        replying: false,
        expand: false,
    }),
    inject: [ 'app', 'commentBoard' ],
    computed: {
        ...mapState({ userid: 'userid', userPrivilege: 'privilege' }),
        replies() {
            return this.expand ? this.comment.replies : this.comment.replies.slice(0, 5);
        },
        needPackup() {
            return this.comment.replies.length > 5;
        },
        hasDeletePrivilege() {
            return checkPrivilege({ comment: 3 }, this.userPrivilege);
        },
    },
    methods: {
        toggleExpand() {
            this.expand = !this.expand;
        },
        triggerWriteboard() {
            this.open = !this.open;
            if (this.open) {
                this.focusWriteboard();
            }
        },
        openWriteboard(reply) {
            this.open = true;
            if (reply) {
                this.replyto = reply.id;
                this.text = `Re #${reply.id}: `;
            } else {
                this.text = '';
            }
            this.focusWriteboard();
        },
        focusWriteboard() {
            this.$nextTick(() => {
                this.$refs.writeboard.focus();
            })
        },
        async manageComment(key) {
            const id = this.comment.id;
            const value = this.comment[key] == 0 ? '1' : '0';
            await this.commentBoard.manageComment({
                id, key, value
            });
        },
        async appendSubcomment() {
            this.replying = true;
            const { comment: { id: pid }, text: content, replyto } = this;
            await this.commentBoard.appendSubcomment({
                pid, content, replyto
            });
            this.replying = false;
            this.replyto = 0;
            this.text = "";
        },
        editComment() {
            this.commentBoard.openEditDialog(this.comment);
        },
        async deleteComment() {
            const { id } = this.comment;
            await this.commentBoard.deleteComment(id);
        },
        async deleteCommentByAdmin() {
            const { id } = this.comment;
            await this.commentBoard.deleteCommentByAdmin(id);
        },
    },
    components: {
        Subcomment, CommentBody,
    }
}
</script>

<style lang="less" scoped>
.subcomment-list {
    margin-left: 20px;
}
.writeboard {
    margin: 10px 15px;
    .ant-input {
        margin-bottom: 5px;
    }
    .textbar {
        .counter {
            &.warn {
                color: red;
            }
            margin: 0 5px;
        }
        .ant-btn {
            span {
                margin: 0px 10px;
            }
        }
        text-align: right;
    }
}
.admin-button {
    color: grey;
}
.ant-tag {
    margin-left: 6px;
    margin-right: 0;
}
</style>

<style scoped>
.subcomment-list >>> .ant-list-header {
    padding: 0;
}
</style>
